<template>
  <div>
  <v-card color="primary darken-2" dark>
    <v-responsive height="400px">
    <v-container fill-height>
      <v-layout align-center>
        <v-flex text-xs-center>
        <v-flex text-xs-center>
          <h2 class="display-1">Система "АТЛАНТ-СМАРТ"</h2>
          <h3>удобная и быстрая система проверки контрагентов и партнеров.</h3>
        </v-flex>
        <br/>
        <v-flex text-xs-center>
          <v-btn color="primary" to="/clients">Поиск контрагентов</v-btn>
        </v-flex>
       </v-flex>
      </v-layout>
    </v-container>
  </v-responsive>
</v-card>
<v-card color="grey lighten-4">
    <v-card-title>
      <div class="headline">Критерии поиска</div>
      <div>
        Система позволяет осуществлять поиск Юридических Лиц на основе текущих и исторических данных о названиях, адресах, руководителях, участниках и уставном капитале компаний. 
      </div>  
    </v-card-title>
</v-card>
<v-card color="grey lighten-4">
    <v-card-title>
      <div class="headline">Аспекты проверки и источники данных</div>
      <div>
        Система позволяет проверять контрагентов на основе данных, полученных из официальных источников.
      </div>
    </v-card-title>
      <v-card-text>
    <v-container fluid grid-list-md>
    <v-layout row wrap>      
        <template v-for="item in aspects">
          <v-flex xs12 sm6>
          <v-card height="100%">
            <v-card-title>
            <v-container fluid grid-list-lg>
            <v-layout row>
              <v-flex xs4>
                <v-img
                  :src="item.img"
                  height="64px"
                  contain
                ></v-img>
              </v-flex>  
              <v-flex xs8>
                  <div>
                    <div class="title">{{item.nameShort}}</div> 
                    <span>{{item.name}}</span>
                  </div>
              </v-flex>
            </v-layout>
            </v-container>
          </v-card-title>
          <v-card-text>
              <div v-for="item in item.items">{{item.name}}</div>
          </v-card-text>          
          </v-card>
          </v-flex>
        </template>

    </v-layout>
</v-container>
</v-card-text>
</v-card>
<v-card color="grey lighten-4">
    <v-card-title>
      <div>
      <div class="headline">Регистрация в системе</div>
      Дополнительные сервисы для зарегистрированных пользователей
      </div>
    </v-card-title>
          <v-card-text>
    <v-container fluid grid-list-md>
    <v-layout row wrap>      
        <template v-for="item in features">
          <v-flex xs12 sm6>
          <v-card height="100%">
            <v-container fluid grid-list-lg>
            <v-layout row>
              <v-flex>
                <v-card-title>
                  <div>
                    <div class="title">{{item.nameShort}}</div> 
                  </div>
                </v-card-title>
                <v-card-text>
                  <span>{{item.name}}</span>
                </v-card-text>
              </v-flex>
            </v-layout>
            </v-container>
          </v-card>
          </v-flex>
        </template>
    </v-layout>
</v-container>
</v-card-text>
</v-card>
</div>
</template>

<script>
  export default {
    name: 'v-home-panel',
    components: {},
    data: () => ({
      aspects: [
        {
          name: 'Федеральная налоговая служба',
          nameShort: 'ФНС',
          img: 'static/img/dbs/fns.svg',
          items: [
            {name: 'Изменения в ЕГРЮЛ'},
            {name: 'Количество сотрудников'},
            {name: 'Специальные налоговые режимы'},
            {name: 'Уплаченные налоги и сборы'},
            {name: 'Налоговая задолженность'},
            {name: 'Лицензии'},
            {name: 'РАФП – Реестр аккредитованных филиалов и представительств иностранных компаний'}
          ]
        },
        {
          name: 'Федеральная служба судебных приставов',
          nameShort: 'ФССП',
          img: 'static/img/dbs/fssp.svg',
          items: [
            {name: 'Исполнительные производства'}
          ]
        },
        {
          name: 'Федеральная служба государственной статистики',
          nameShort: 'Росстат',
          img: 'static/img/dbs/rfss.png',
          items: [
            {name: 'Бухгалтерская отчетность'}
          ]
        },
        {
          name: 'Федеральная служба по интеллектуальной собственности',
          nameShort: 'Роспатент',
          img: 'static/img/dbs/rospatent.png',
          items: [
            {name: 'Товарные знаки и знаки обслуживания'},
            {name: 'Общеизвестные в РФ товарные знаки'}
          ]
        }
      ],
      features: [
        {
          nameShort: 'Мои контрагенты',
          name: 'Позволяет использовать общие списки контрагентов для представителей одной компании и вносить примечания, видимые этим представителям'
        },
        {
          nameShort: 'Мониторинг',
          name: 'Позволяет отслеживать изменения, которые вносятся в ЕГРЮЛ вашими контрагентами. Это позволяет избежать сюрпризов и быть в курсе об изменнених происходящих у Ваших партнеров.'
        }
      ]
    }),
    mounted () {
    },
    computed: {
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// HomePanel.vue?34d16502